import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getSensorTypeTitle = (record, translate) =>
  `${translate("resources.device.fields.sensor_type_id")} ${record.id} (${
    record.name
  })`;

const Edit = (props) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      undoable={false}
      title={<DynamicTitleWithTooltip getTitle={getSensorTypeTitle} />}
    >
      <Form />
    </RaEdit>
  );
};
export default Edit;
